import { fromJS  } from 'immutable';

export const State = fromJS({
  isPutting: false,
  errMsg: ''
});